/**
 * 列表页 - 模板路由入口
 * 
 * 根据用户选择的模板ID，加载对应版本的列表页组件
 */

import { useTemplate } from "@/context/TemplateContext";

// ============================================
// 导入各模板组件
// ============================================

import ClassicCategoryPage from "@/templates/classic/category/CategoryPage";
import ModernCategoryPage from "@/templates/modern/category/CategoryPage";
import DarkCategoryPage from "@/templates/dark/category/CategoryPage";
import GreenCategoryPage from "@/templates/green/category/CategoryPage";
import RedCategoryPage from "@/templates/red/category/CategoryPage";
import TechBlueCategoryPage from "@/templates/tech-blue/category/CategoryPage";
import DeepBlueCategoryPage from "@/templates/deep-blue/category/CategoryPage";
import TealCategoryPage from "@/templates/teal/category/CategoryPage";
import SunsetCategoryPage from "@/templates/sunset/category/CategoryPage";
import PurpleCategoryPage from "@/templates/purple/category/CategoryPage";

// ============================================
// 模板映射表
// ============================================

const templateComponents = {
  classic: ClassicCategoryPage,
  modern: ModernCategoryPage,
  dark: DarkCategoryPage,
  green: GreenCategoryPage,
  red: RedCategoryPage,
  "tech-blue": TechBlueCategoryPage,
  "deep-blue": DeepBlueCategoryPage,
  teal: TealCategoryPage,
  sunset: SunsetCategoryPage,
  purple: PurpleCategoryPage,
};

// ============================================
// 列表页组件
// ============================================

export default function CategoryPage() {
  const { templateId } = useTemplate();
  
  // 根据模板ID选择对应组件，默认使用经典模板
  const TemplateComponent = templateComponents[templateId as keyof typeof templateComponents] || ClassicCategoryPage;
  
  return <TemplateComponent />;
}
